import Plus from './src/plus-combined';
export default Plus;